<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-container>
          <dashboard-filtro-mais-vida
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :empresas1="enableEmpresa"
            :url="link"
            :clientes="enableClientes"
            :cidades="enableCidades"
            :cidades1="enableCidades"
            :areas="enableAreas"
            :areas1="enableAreas"
            :vendedores="enableVendedores"
            :vendedores1="enableVendedores"
            :redes="enableRedes"
            :redes1="enableRedes"
            :produtos="enableProdutos"
            :linhas="enableLinhas"
            :btn1="enableBtn"
            :btn2="disableBtn"
            :enable-datas="enableDatas"
            :enable-datas1="enableDatas"
            :filtro-completo="enableFiltro"
            :texto-filtro="enableTextoFiltro"
            :segmentos="enableSegmento"
            :segmentos1="enableSegmento"
          />
          <v-container>
            <v-row
              v-if="enableBtnPrint"
              id="btnPrint"
            >
              <v-btn
                class="col-4 col-sm-3 col-md-1 col-lg-1"
                small
                :color="corPrimaria"
                dark
                :loading="imprimindo"
                @click="imprimir()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Imprimir
                <template v-slot:loader>
                  <span>Imprimindo...</span>
                </template>
              </v-btn>
            </v-row>
          </v-container><br>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Participação Linha de Produção
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('230')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-comparativo-faturamento id="componenteComparativoFaturamento" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'PageMaisVida04',
    emits: ['updateFormMaisVida', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardComparativoFaturamento: () => import('../../components/comercial/ComparativoFaturamento'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      link: window.location.href,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select: [],
      cidades: [],
      areas: [],
      vendedores: [],
      redes: [],
      produtos: [],
      linhas: [],
      clientes: [],
      dataInicial1: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal1: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select1: [],
      cidades1: [],
      areas1: [],
      vendedores1: [],
      redes1: [],
      produtos1: [],
      linhas1: [],
      clientes1: [],
      segmento: [],
      segmento1: [],
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: true,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: true,
      enableProdutos: false,
      enableLinhas: false,
      enableBtn: true,
      disableBtn: false,
      enableDatas: true,
      enableTextoFiltro: false,
      enableSegmento: true,
      enableFiltro: true,
      codigo: 0,
      orientacao: [],
      textoLinhaProducao: '',
      codigoIds: ['230'],
      dynamicPaddingLinhaProducao: '',
      enableBtnPrint: false,
      imprimindo: false,
      headersFaturamentoxLinha: [
        { text: 'Linhas Produção', value: 'linhas', align: 'left', class: 'black--text title' },
        { text: '%', value: 'porcentagem1', align: 'right', class: 'black--text title' },
        { text: 'Faturamento P1', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'V%', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: '%', value: 'porcentagem2', align: 'right', class: 'black--text title' },
        { text: 'Faturamento P2', value: 'valor2', align: 'right', class: 'black--text title' },
      ],
      dadosFaturamento: [],
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$on('set-dados-comparativo-faturamento', this.handleDadosComparativoFaturamento)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$off('set-dados-comparativo-faturamento', this.handleDadosComparativoFaturamento)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Linha Produção')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingLinhaProducao = 'padding-right: 107rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingLinhaProducao = 'padding-right: 87rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingLinhaProducao = 'padding-right: 12rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingLinhaProducao = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingLinhaProducao = 'padding-right: 65rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, tipoDevolucao, motivoDevocucao, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, selectReceita, selectSegmento, selectSegmento1) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.select = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.linhas = linhaSelect
        this.clientes = clienteSelect
        this.dataInicial1 = dataInicial1
        this.dataFinal1 = dataFinal1
        this.select1 = empresaSelect1
        this.cidades1 = cidadeSelect1
        this.areas1 = areaSelect1
        this.redes1 = redeSelect1
        this.vendedores1 = vendedorSelect1
        this.produtos1 = produtoSelect1
        this.linhas1 = linhaSelect1
        this.clientes1 = clienteSelect1
        this.segmento = selectSegmento
        this.segmento1 = selectSegmento1

        this.enableBtnPrint = false

        this.updateDados()
      },

      handleDadosComparativoFaturamento (dados) {
        this.dadosFaturamento = dados

        this.enableBtnPrint = true
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      updateDados () {
        eventEmit.$emit('update-form-mais-vida', this.dataInicial, this.dataFinal, this.select, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.linhas, this.clientes, this.dataInicial1, this.dataFinal1, this.select1, this.cidades1, this.areas1, this.vendedores1, this.redes1, this.produtos1, this.linhas1, this.clientes1, this.segmento, this.segmento1)
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')
          let posYFiltros = 10

          const filtro = 'Filtros selecionados período 1 (P1)'
          pdf.text(filtro, 15, posYFiltros)

          const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
          const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados, xPosition) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 70)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, xPosition, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, xPosition, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao), 15)
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade), 15)
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area), 15)
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor), 15)
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede), 15)
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento), 15)

          const posYFiltrosP1 = posYFiltros

          let posYFiltroP2 = 10

          pdf.setFontSize(16)
          const filtro1 = 'Filtros selecionados período 2 (P2)'
          pdf.text(filtro1, 150, posYFiltroP2)

          posYFiltroP2 += 10

          const dataInicial1 = this.dataInicial1.substr(8) + '/' + this.dataInicial1.substr(5, 2) + '/' + this.dataInicial1.substr(0, 4)
          const ultimoDia1 = this.dataFinal1.substr(8) + '/' + this.dataFinal1.substr(5, 2) + '/' + this.dataFinal1.substr(0, 4)

          const datas1 = 'Data inicial: ' + dataInicial1 + ' - Data final: ' + ultimoDia1
          pdf.setFontSize(10)
          pdf.text(datas1, 150, posYFiltroP2)

          posYFiltroP2 += 10

          posYFiltroP2 = await adicionarFiltros(pdf, posYFiltroP2, 'Empresa(s) Selecionada(s):', this.select1.map(e => e.nomeExibicao), 150)
          posYFiltroP2 = await adicionarFiltros(pdf, posYFiltroP2, 'Cidade(s) Selecionada(s):', this.cidades1.map(e => e.cidade), 150)
          posYFiltroP2 = await adicionarFiltros(pdf, posYFiltroP2, 'Área(s) Selecionada(s):', this.areas1.map(a => a.area), 150)
          posYFiltroP2 = await adicionarFiltros(pdf, posYFiltroP2, 'Vendedor(es) Selecionado(s):', this.vendedores1.map(v => v.vendedor), 150)
          posYFiltroP2 = await adicionarFiltros(pdf, posYFiltroP2, 'Rede(s) Selecionada(s):', this.redes1.map(r => r.rede), 150)
          posYFiltroP2 = await adicionarFiltros(pdf, posYFiltroP2, 'Segmento(s) Selecionado(s):', this.segmento1.map(se => se.segmento), 150)

          posYFiltros = posYFiltrosP1 >= posYFiltroP2 ? posYFiltrosP1 : posYFiltroP2

          pdf.line(147, 5, 147, posYFiltros)

          if (posYFiltros > 120) {
            pdf.addPage()
            posYFiltros = 10
          }

          const title = 'Participação Linha de Produção'
          pdf.setFontSize(14)
          pdf.text(title, 15, posYFiltros)

          posYFiltros += 5

          const dadosTabelas = this.dadosFaturamento.map(item => [item.linhas, item.porcentagem1, item.valor1, this.getPercentual(item.variacao), item.porcentagem2, item.valor2])

          pdf.autoTable({
            head: [this.headersFaturamentoxLinha.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: dadosTabelas.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
            startY: posYFiltros,
            styles: { fontSize: 10 },
          })

          pdf.save('relatorio_linha_producao.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.dadosFaturamento = []

          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      getPercentual (value) {
        if (value !== '-') {
          return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
        }

        return '-'
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #componenteComparativoFaturamento {
    margin: -3rem 0 0 0
  }

  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">
  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemLinhaProducao
    margin: -2rem 0 0 -1rem

</style>
